import { InjectionToken } from "@angular/core";
import { Observable } from "rxjs";

export abstract class IContextService
{

  abstract contextGet(): string;

  abstract contextChangeGet(): Observable<string>;

  abstract contextSetDefault(): void;

  abstract contextSet(context: string): void;

  abstract contextTriggerUiRefresh(): void;

  abstract contextUiRefreshChangedGet(): Observable<void>;

}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IContextServiceToken = new InjectionToken<IContextService>('IContextServiceToken');
